import React, { FC } from "react";
import styled from "styled-components";
import { Button, Col, Row, Typography, Image, Popover } from "antd";
import logobw from "../assets/images/logo-bw.png";
import ColorLogo from "../assets/images/logo.png";

import AvatarIcon from "../assets/images/avatar-icon.png";
import { NavLink, useHistory } from "react-router-dom";
import { getCookies, getUserData } from "../utils/utilsFunctions";
import Pop from "./Pop";
import MobileMenu from "./MobileMenu";
import { SETUP_PAYMENT } from '../Apollo/graphql/Mutation/SetupPayment';
import { useMutation } from "@apollo/client";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { useStoreState } from '../myStore/index';

interface HeaderProps {
  bg?: string;
}
const HeaderContainer = styled(Row)`
  display: flex;
  /* background-color: red; */
  width: 100%;
`;
const ContentSection = styled(Col)`
  width: 100%;
`;
const Header = styled(Col) <HeaderProps>`
  display: flex;
  background-color: ${(props) => (props.bg ? props.bg : "transparent")};
  min-height: 100px;
  width: 100%;
  justify-content: space-between;
   align-items: center;
  padding: 0 7rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);


  @media screen and (max-width: 1000px) {
    padding: 0 1.5rem;
    justify-content: space-between;
  }
`;
const PopoverX = styled(Popover)`
  @media screen and (max-width: 768px) {
    display: none;
  }
`
interface TProps {
  color?: string;
}
const LogoImg = styled.img`
  height: 45px;
  margin-top: -10px;
`;

const HeaderItem = styled(Typography) <TProps>`
  &.ant-typography {
    font-family: "Rogan";
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: 0;
    cursor: pointer;
    color: ${(props) => (props.color ? props.color : "#000")};

    :hover{
      color: #1196dd;
    }
    @media screen and (max-width: 1600px) {
      font-size: 1rem;
      }

    @media screen and (max-width: 990px) {
      display: none;
      }
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const ButtonStyle = styled(Button)`
  text-transform: uppercase;
  font-family: "Rogan";
  font-size: 18px;
  font-weight: bold;
  border: none;
  height: 2.5rem;
  box-shadow: none;
  margin-right: 2rem;

  @media screen and (max-width: 768px) {
    display: none;
  }
  @media screen and (max-width: 968px) {
    border-radius: 50px;

    &:hover {
      box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
        rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
        rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset,
        rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,
        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,
        rgba(0, 0, 0, 0.09) 0px 32px 16px;
    }
  }
`;

const MainSection = styled.div`
  width: 140px;
  background: white;
  display: flex;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  z-index: 999;
`;

const IconDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 18px;
  padding: 1rem 0;
`;
const IconSection = styled.div`
  display: flex;

  &:hover {
    color: #1196dd;
  }
`;
const MobileRemoveDiv = styled.div`
  @media screen and (max-width: 1024px) {
    display: none;
  }
`

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const NavigationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 100vw;
  @media screen and (max-width: 768px) {
    max-width: 100vw;
  }
`;
const ButtonSpan = styled.span`
  text-decoration: underline; 
  color: #1196dd;

`

const NavMenuItem = styled(NavLink)`
  margin-right: 2rem;
  position: relative;
  .menu-meta-count {
    border-radius: 50%;
    background-color: #1196DD;
    position: absolute;
    top: -14px;
    padding: 4px;
    color: #FFF;
    font-size: 13px;
    font-weight: 600;
    height: 24px;
    width: 23px;
    text-align: center;
    right: -15px;
  }
`;

export interface Props {
  bg?: string;
  white?: string;
  color?: string;
  logo?: boolean;
}

const NavBarDropDownList = () => {
  const history = useHistory();
  return (
    <MainSection>
      <IconDiv>
        <IconSection onClick={() => history.push("/signin")}>
          <span>Log In</span>
        </IconSection>
      </IconDiv>
      <IconDiv>
        <IconSection onClick={() => history.push("/register")}>
          <span>Register</span>
        </IconSection>
      </IconDiv>
    </MainSection>
  );
};

const HeaderComponent: FC<Props> = (props: Props) => {
  const user = JSON.parse(getUserData('user'));

  const isSeller = user?.isSeller === true;
  const isPaymentSetUpComplete = user?.paymentSetupComplete === true;
  const [setupPayment] = useMutation(SETUP_PAYMENT);

  const history = useHistory();
  const orderCart = useStoreState((state: any) => state.cart.orderCart);
  const handleStripeAccount = async () => {
    const data: any = await setupPayment();
    if (data && data.data.setupPayment) {
      window.location.replace(data.data.setupPayment.url);
    }

  };

  // return null;

  return (
    <>
      {
        isSeller ? (
          !isPaymentSetUpComplete ?
            (<p
              style={{ width: '100%', backgroundColor: '#F7B217', cursor: 'pointer', textAlign: 'center', marginBottom: 0 }}
            >
              Your payment setup is not completed yet ! {" "}
              <ButtonSpan style={{ textDecoration: 'underline', color: '#1196dd', }}
                onClick={handleStripeAccount}
              >
                click here </ButtonSpan>
              {" "}to complete.
            </p>)
            : ""
        ) : ""
      }
      <HeaderContainer>
        <ContentSection>
          <Header bg={props.bg}>
            <LogoWrapper>
              <NavLink to="/">
                <LogoImg src={props.logo ? logobw : ColorLogo} alt="" />
              </NavLink>
            </LogoWrapper>
            <NavigationWrapper>
              <NavMenuItem to="/marketplace">
                <HeaderItem color={props.color}>MARKETPLACE</HeaderItem>
              </NavMenuItem>
              <NavMenuItem to="/printers">
                <HeaderItem color={props.color}>PRINTERS</HeaderItem>
              </NavMenuItem>
              <NavMenuItem to="/aboutus" >
                <HeaderItem color={props.color}>FAQ</HeaderItem>
              </NavMenuItem>
              <NavMenuItem to="/why-use-3dprintit" >
                <HeaderItem color={props.color}>Why use 3Dprintit?</HeaderItem>
              </NavMenuItem>
              {
                !getCookies() ? (
                  <NavMenuItem to="/register?becomeSeller">
                    <HeaderItem color={props.color}>Become a Seller</HeaderItem>
                  </NavMenuItem>
                ) : ""
              }
              <ButtonStyle
                type="primary"
                onClick={() => history.push("/design/upload")}
              >
                Get An Instant Quote
              </ButtonStyle>
              <NavMenuItem to="/design/cart"><HeaderItem color={props.color}><ShoppingCartOutlined style={{ fontSize: "16px"}} />
                {orderCart.packages.length > 0 && <span className="menu-meta-count">{orderCart.packages.length}</span>}
              </HeaderItem></NavMenuItem>
              <MobileRemoveDiv>
                {!!getCookies() ? (
                  <Pop color={props.color} />
                ) : (
                  <PopoverX
                    trigger="click"
                    placement="bottomRight"
                    content={NavBarDropDownList}
                  >
                    <Image
                      src={AvatarIcon}
                      width={30}
                      preview={false}
                      style={{ background: "#000", borderRadius: '50%', marginRight: "1rem", cursor: "pointer" }}
                    />
                  </PopoverX>
                )}
              </MobileRemoveDiv>
              <MobileMenu color={props.color} />
            </NavigationWrapper>
          </Header>
        </ContentSection>
      </HeaderContainer>
    </>
  );
};

export default HeaderComponent;
